import React from 'react';

// 额外语言字段配置——和 ProductDialog.jsx 用的是同一套语言代码/标签，
// 保持整个系统里"哪个代码对应哪种语言"这件事统一，不会两处写法不一致
const LANGUAGE_FIELD_CONFIG = [
  { code: 'en',    field: 'shop_name_en',    label: '英文名',     placeholder: 'Taiwan Shop' },
  { code: 'km',    field: 'shop_name_km',    label: '高棉语名' },
  { code: 'ms',    field: 'shop_name_ms',    label: '马来语名' },
  { code: 'zh_tw', field: 'shop_name_zh_tw', label: '繁体中文名' },
];

const ShopNameCard = ({ settings, onChange, enabledLanguages = ['en', 'km'] }) => {
  const visibleFields = LANGUAGE_FIELD_CONFIG.filter(l => enabledLanguages.includes(l.code));

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <h3 className="font-semibold mb-4">店铺名称</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">中文名 *</label>
          <input type="text" value={settings.shop_name}
            onChange={e => onChange('shop_name', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="台灣柑仔店" />
        </div>
        {/* 额外语言输入框：只显示商家设置里"启用的语言"里有的那几个，
            商家把某个语言关掉之后，这里对应的输入框会跟着消失，不用手动去改 */}
        {visibleFields.map(lang => (
          <div key={lang.code}>
            <label className="block text-sm font-medium mb-1">{lang.label}</label>
            <input type="text" value={settings[lang.field] || ''}
              onChange={e => onChange(lang.field, e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder={lang.placeholder} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopNameCard;